<template>
  <transition name="fade">
    <div v-if="showTutorial" class="tutorial-container">
      <flickity
        id="flickity-tutorial"
        ref="flickityTutorial"
        :options="flickityOptions"
        @change="onChangeSlide"
      >
        <div class="carousel-cell" v-for="page in pages" :key="page">
          <img :src="imageUrl(page)" alt="" />
        </div>
      </flickity>
      <div class="controller-container">
        <ul>
          <li v-for="page in pages" :key="page" :class="page === currentPage && 'active'" />
        </ul>
        <button @click="nextPage">
          {{ nextPageButtonLabel }}
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
import Flickity from 'vue-flickity-2/src/Flickity'
import 'vue-flickity-2/dist/vue-flickity-2.css'
import { mapActions } from 'vuex'

export default {
  name: 'CouponWithCartTutorial',
  components: { 'flickity': Flickity },
  data() {
    return {
      apiTypeNeedsCouponTutorial: 15,
      showTutorial: false,
      flickityOptions: {
        prevNextButtons: false,
        pageDots: false
      },
      pages: 3,
      currentPage: 1
    }
  },
  created() {
    window.receivedNeedsCouponTutorial = async (payload) => {
      this.showTutorial = payload === '1'
    }
    this.actionRequestNeedsCouponTutorial()
  },
  computed: {
    nextPageButtonLabel() {
      return this.currentPage < 3 ? '次へ' : 'クーポン選択へ'
    }
  },
  methods: {
    ...mapActions('Native', [
      'actionRequestNeedsCouponTutorial'
    ]),
    imageUrl(page) {
      return require(`../../assets/img/coupon-with-cart/tutorial-${page}.png`)
    },
    onChangeSlide(index) {
      this.currentPage = index + 1
    },
    nextPage() {
      if (this.currentPage < 3) {
        this.$refs.flickityTutorial.flickity.select(this.currentPage, false, false)
      } else {
        this.showTutorial = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.tutorial-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.85);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  z-index: 4;

  #flickity-tutorial {
    width: 100%;
    height: 70%;

    .carousel-cell {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: flex-end;

      img {
        width: 100%;
      }
    }
  }

  .controller-container {
    height: 30%;
    display: flex;
    flex-direction: column;
    align-items: center;

    button {
      width: 200px;
      height: 40px;
      border: 1px solid #ffffff;
      border-radius: 6px;
      color: #ffffff;
      font-weight: bold;
    }

    ul {
      display: flex;
      justify-content: center;
      margin: 30px auto;

      & > * + * {
        margin-left: 12px;
      }

      li {
        list-style: none;
        background: rgba(255, 255, 255, 0.3);
        width: 12px;
        height: 12px;
        border-radius: 12px;

        &.active {
          background: rgba(255, 255, 255, 1.0);
        }
      }
    }
  }

}
</style>
